import {
  GridToolbar,
  GridToolbarQuickFilter,
} from '@packages/fenrir/components/datagrid';
import { styled } from '@packages/fenrir/styles';

import { useSecurityJourneyTranslations } from '../../../locales/use-security-journey-translations';

/* -------------------------------------------------------------------------------------------------
 * TableToolbar
 * -----------------------------------------------------------------------------------------------*/
const TableToolbarContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

export const TableToolbar = () => {
  const { t } = useSecurityJourneyTranslations();

  return (
    <TableToolbarContainer>
      <GridToolbarQuickFilter
        placeholder={t(
          'common.blueprintsTable.filters.quickFilter.placeholder',
        )}
      />
      <GridToolbar />
    </TableToolbarContainer>
  );
};
